import React, { useState, useEffect } from "react";


function Carousel() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [
    {
      src: "https://nishnaiholidays.com/wp-content/uploads/2022/12/IMG-World-of-Adventuresq.jpg",
      alt: "Slide 2",
    },
    {
      src: "https://th.bing.com/th/id/OIP._WbHP22PLW491vK_L_sT_wHaFj?rs=1&pid=ImgDetMain",
      alt: "Slide 3",
    },
    {
      src: "https://th.bing.com/th/id/OIP.FxTMCa94uRmS7kF6nvW2ugHaFC?rs=1&pid=ImgDetMain",
      alt: "Slide 4",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 2000); // Change slide every second

    return () => clearInterval(interval); // Clean up interval on component unmount
  }, [slides.length]);

  return (
    <div className="HeroCarousel">
      <div className="carousel-main" style={{ overflow: "hidden" }}>
        <div
          className="carousel-inner"
          style={{
            display: "flex",
            transition: "transform 0.5s ease-in-out",
            transform: `translateX(-${currentSlide * 100}%)`,
          }}
        >
          {slides.map((slide, index) => (
            <div
              key={index}
              className={`carousel-item ci-${index}`}
              style={{
                backgroundImage: `url(${slide.src})`,
              }}
            >
              <p>{slide.text}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="HeroCarousel-Side">
        <ul>
          <li>
            <img src="https://www.ccsuniversity.ac.in/assests/images/ccs-1-22.jpg" alt="" />
            <p>Hon'ble Chaudhary Charan Singh Ji</p>
            <h5>Bharat Ratna & Former Prime Minister</h5>
            {/* <Link>View More</Link> */}
          </li>
          <li>
            <img src="https://www.ccsuniversity.ac.in/assests/images/chancellor.png" alt="" />
            <p>Smt. Anandiben Patel</p>
            <h5>Hon'ble Chancellor</h5>
            {/* <Link>View More</Link> */}
          </li>
          <li>
            <img src="https://www.ccsuniversity.ac.in/assests/images/vc-img.jpg"  alt=""/>
            <p>Prof. Sangeeta Shukla</p>
            <h5>Hon'ble Vice-Chancellor</h5>
            {/* <Link>View More</Link> */}
          </li>
        </ul>
      </div>
    </div>
  );
}

export default Carousel;
